import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    margin: '16px',
    width: '1200px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    maxHeight: '-webkit-fill-available',
    overflowY: 'scroll',
    [theme.breakpoints.down('500')]: {
      width: '100%',
      margin: 0,
      maxHeight: 'none',
      height: 'inherit',
      borderRadius: 0,
      overflow: 'unset'
    },
  },
  container: {
    paddingLeft: 16,
    paddingRight: 16
  },
}))
